<template>
    <b-button
        variant="warning"
        @click.stop="confirmarEncerrarContrato()"
        class="ml-1"
    >
        <span> <i class="fa fa-minus-circle mr-2"></i> Encerrar Contrato </span>
    </b-button>
</template>

<script>
import ContratosServicos from './ContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarEncerrarContrato() {
            this.$swal({
                title: 'Encerrar Contrato',
                html: `Confirma o encerramento do contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor.nome}</b>?
                <br/><br/><div class="alert alert-danger" role="alert">
                        Atenção! Essa é uma operação irreversível!
                    </div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.encerrarContrato()
                }
            })
        },

        encerrarContrato() {
            this.$store.dispatch('addRequest')
            let contratoDto = {
                idContrato: this.contrato.idContrato,
                operacao: 'E'
            }
            ContratosServicos.ajustarContrato(contratoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro salvo com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterContratoAtualizado')
                    } else {
                        this.$emit('atualizarMensagensErros', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
